import { formatEur } from '@aviaconsole/shared';
export { formatEur };

export function formatDate(iso: string | null | undefined, lang: 'en' | 'nl' = 'en', withTime = false): string {
  if (!iso) return '—';
  const d = new Date(iso.length === 10 ? iso + 'T00:00:00' : iso);
  return new Intl.DateTimeFormat(lang === 'nl' ? 'nl-NL' : 'en-GB', {
    day: '2-digit', month: 'short', year: 'numeric', ...(withTime ? { hour: '2-digit', minute: '2-digit' } : {}),
  }).format(d);
}

export function relative(iso: string, lang: 'en' | 'nl' = 'en'): string {
  const diff = Date.now() - Date.parse(iso);
  const rtf = new Intl.RelativeTimeFormat(lang === 'nl' ? 'nl' : 'en', { numeric: 'auto' });
  const min = Math.round(diff / 60_000);
  if (Math.abs(min) < 60) return rtf.format(-min, 'minute');
  const h = Math.round(min / 60);
  if (Math.abs(h) < 24) return rtf.format(-h, 'hour');
  return formatDate(iso, lang);
}

/** Time left until a deadline: "1 h 20 m left" / "Paused" / "Met". */
export function slaLabel(dueAt: string | null, respondedAt: string | null, status: string, lang: 'en' | 'nl'): { label: string; tone: string } {
  if (respondedAt) return { label: lang === 'nl' ? 'Gehaald' : 'Met', tone: 'success' };
  if (status === 'waiting_on_customer' || status === 'resolved' || status === 'closed') return { label: lang === 'nl' ? 'Gepauzeerd' : 'Paused', tone: 'neutral' };
  if (!dueAt) return { label: '—', tone: 'neutral' };
  const ms = Date.parse(dueAt) - Date.now();
  const left = lang === 'nl' ? 'over' : 'left';
  if (ms < 0) return { label: lang === 'nl' ? 'Overschreden' : 'Breached', tone: 'danger' };
  const h = Math.floor(ms / 3_600_000), m = Math.floor((ms % 3_600_000) / 60_000);
  if (h >= 48) return { label: `${Math.round(h / 24)} d ${left}`, tone: 'primary' };
  if (h >= 6) return { label: `${h} h ${left}`, tone: 'primary' };
  return { label: `${h} h ${m} m ${left}`, tone: 'warning' };
}
